import { Newspaper } from 'lucide-react';
import { type ComponentType, lazy } from 'react';
import type { RouteObject } from 'react-router';
import type { ModuleDefinition } from '../../app/modules';
import { ContentTaskBadges } from './TaskBadges';

/**
 * Контент, сторінки послуг і розвиток послуг (М11): реєстр «Наповнення сайту» з карткою матеріалу
 * (маршрут етапів з умовами й автопризначенням, SEO трьома мовами, унікальність, чек-лист, фіксація редактури,
 * погодження, публікації, історія, ШІ-помічник), черга погоджень, публікації, редакційний календар,
 * паспорти нових і посилених послуг з пакетами, кейси «Маркетинг», норми й звіти, довідники.
 * Картка матеріалу відкривається з будь-якого розділу: /content/materials?material=<id>.
 * У задачі матеріалу чи паспорта — рядок реквізитів і код у переліках (task.ext.content).
 */
const ContentTaskFields = lazy(() => import('./TaskFields'));

const page = (load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> => ({
  lazy: async () => ({ Component: (await load()).default }),
});

const contentModule: ModuleDefinition = {
  key: 'content',
  label: 'Контент',
  icon: Newspaper,
  basePath: '/content',
  scope: 'projects:read',
  order: 60,
  routes: [
    {
      ...page(() => import('./ContentLayout')),
      children: [
        { index: true, lazy: async () => ({ Component: (await import('./ContentLayout')).ContentIndex }) },
        { path: 'materials', ...page(() => import('./pages/MaterialsPage')) },
        { path: 'approvals', ...page(() => import('./pages/ApprovalsPage')) },
        { path: 'publications', ...page(() => import('./pages/PublicationsPage')) },
        { path: 'calendar', ...page(() => import('./pages/CalendarPage')) },
        { path: 'services', ...page(() => import('./pages/ServicesPage')) },
        { path: 'marketing', ...page(() => import('./pages/MarketingPage')) },
        { path: 'reports', ...page(() => import('./pages/ReportsPage')) },
        { path: 'settings', ...page(() => import('./pages/SettingsPage')) },
      ],
    },
  ],
  task: { Fields: ContentTaskFields, Badges: ContentTaskBadges },
};

export default contentModule;
